import { SupportedLanguage } from './languages';

export const uiTranslations: Record<string, Record<SupportedLanguage, string>> = {
  aiPowered: {
    English: "AI-POWERED",
    Spanish: "IMPULSADO POR IA",
    French: "PROPULSÉ PAR L'IA",
    German: "KI-GESTÜTZT",
    Chinese: "AI 驱动",
    Japanese: "AI 搭載",
    Korean: "AI 기반",
    Portuguese: "IMPULSIONADO POR IA",
    Italian: "POTENZIATO DALL'IA",
    Russian: "НА БАЗЕ ИИ",
    Arabic: "مدعوم بالذكاء الاصطناعي",
    Hebrew: "מופעל על ידי בינה מלאכותית",
    Hindi: "एआई-संचालित",
    Bengali: "এআই-চালিত",
    Hungarian: "MI-ALAPÚ",
    Romanian: "ALIMENTAT DE IA"
  },
  masterEnglishNaturally: {
    English: "Master English Naturally",
    Spanish: "Domina el inglés de forma natural",
    French: "Maîtrisez l'anglais naturellement",
    German: "Englisch natürlich meistern",
    Chinese: "自然地掌握英语",
    Japanese: "自然に英語をマスターする",
    Korean: "자연스럽게 영어를 마스터하세요",
    Portuguese: "Domine o inglês naturalmente",
    Italian: "Padroneggia l'inglese in modo naturale",
    Russian: "Осваивайте английский естественно",
    Arabic: "أتقن الإنجليزية بشكل طبيعي",
    Hebrew: "לשלוט באנגלית באופן טבעי",
    Hindi: "स्वाभाविक रूप से अंग्रेजी सीखें",
    Bengali: "স্বাভাবিকভাবে ইংরেজি আয়ত্ত করুন",
    Hungarian: "Sajátítsa el az angolt természetesen",
    Romanian: "Stăpânește engleza în mod natural"
  },
  practiceSpeakingWithRealTimeAiFeedback: {
    English: "Practice speaking with real-time AI feedback. Improve your pronunciation and fluency.",
    Spanish: "Practica hablar con comentarios de IA en tiempo real. Mejora tu pronunciación y fluidez.",
    French: "Entraînez-vous à parler avec des commentaires de l'IA en temps réel. Améliorez votre prononciation et votre fluidité.",
    German: "Üben Sie das Sprechen mit KI-Feedback in Echtzeit. Verbessern Sie Ihre Aussprache und Ihren Redefluss.",
    Chinese: "通过实时 AI 反馈练习说话。提高您的发音和流利度。",
    Japanese: "リアルタイムの AI フィードバックでスピーキングを練習しましょう。発音と流暢さを向上させます。",
    Korean: "실시간 AI 피드백으로 말하기를 연습하세요. 발음과 유창성을 향상시키세요.",
    Portuguese: "Pratique a fala com feedback de IA em tempo real. Melhore sua pronúncia e fluência.",
    Italian: "Esercitati a parlare con il feedback dell'IA in tempo real. Migliora la tua pronuncia e fluidità.",
    Russian: "Практикуйте разговорную речь с обратной связью от ИИ в реальном времени. Улучшите свое произношение и беглость речи.",
    Arabic: "تدرب على التحدث مع تعليقات الذكاء الاصطناعي في الوقت الفعلي. حسن نطقك وطلاقتك.",
    Hebrew: "תרגל דיבור עם משוב בינה מלאכותית בזמן אמת. שפר את ההגייה והשטף שלך.",
    Hindi: "रीयल-टाइम एआई फीडबैक के साथ बोलने का अभ्यास करें। अपने उच्चारण और प्रवाह में सुधार करें।",
    Bengali: "রিয়েল-টাইম এআই প্রতিক্রিয়ার সাথে কথা বলার অনুশীলন করুন। আপনার উচ্চারণ এবং সাবলীলতা উন্নত করুন।",
    Hungarian: "Gyakorolja a beszédet valós idejű MI-visszajelzéssel. Javítsa kiejtését és folyékonyságát.",
    Romanian: "Exersează vorbirea cu feedback AI în timp real. Îmbunătățește-ți pronunția și fluența."
  },
  practiceArea: {
    English: "Practice Area",
    Spanish: "Área de práctica",
    French: "Zone d'entraînement",
    German: "Übungsbereich",
    Chinese: "练习区",
    Japanese: "練習エリア",
    Korean: "연습 구역",
    Portuguese: "Área de prática",
    Italian: "Area di pratica",
    Russian: "Зона практики",
    Arabic: "منطقة التدريب",
    Hebrew: "אזור תרגול",
    Hindi: "अभ्यास क्षेत्र",
    Bengali: "অনুশীলনের ক্ষেত্র",
    Hungarian: "Gyakorló terület",
    Romanian: "Zonă de practică"
  },
  recordAndListen: {
    English: "RECORD & LISTEN",
    Spanish: "GRABAR Y ESCUCHAR",
    French: "ENREGISTRER ET ÉCOUTER",
    German: "AUFNEHMEN & ANHÖREN",
    Chinese: "录音并收听",
    Japanese: "録音して聴く",
    Korean: "녹음 및 듣기",
    Portuguese: "GRAVAR E OUVIR",
    Italian: "REGISTRA E ASCOLTA",
    Russian: "ЗАПИСАТЬ И ПРОСЛУШАТЬ",
    Arabic: "سجل واستمع",
    Hebrew: "הקלט והאזן",
    Hindi: "रिकॉर्ड करें और सुनें",
    Bengali: "রেকর্ড করুন এবং শুনুন",
    Hungarian: "RÖGZÍTÉS ÉS HALLGATÁS",
    Romanian: "ÎNREGISTREAZĂ ȘI ASCULTĂ"
  },
  readThisAloud: {
    English: "READ THIS ALOUD",
    Spanish: "LEE ESTO EN VOZ ALTA",
    French: "LISEZ CECI À HAUTE VOIX",
    German: "LIES DIES LAUT VOR",
    Chinese: "大声朗读",
    Japanese: "これを音読してください",
    Korean: "이것을 크게 읽으세요",
    Portuguese: "LEIA ISTO EM VOZ ALTA",
    Italian: "LEGGI AD ALTA VOCE",
    Russian: "ПРОЧИТАЙТЕ ЭТО ВСЛУХ",
    Arabic: "اقرأ هذا بصوت عالٍ",
    Hebrew: "קרא זאת בקול רם",
    Hindi: "इसे जोर से पढ़ें",
    Bengali: "এটি জোরে পড়ুন",
    Hungarian: "OLVASSA FEL EZT",
    Romanian: "CITEȘTE ACESTA CU VOCE TARE"
  },
  previous: {
    English: "Previous",
    Spanish: "Anterior",
    French: "Précédent",
    German: "Zurück",
    Chinese: "上一页",
    Japanese: "前へ",
    Korean: "이전",
    Portuguese: "Anterior",
    Italian: "Precedente",
    Russian: "Назад",
    Arabic: "السابق",
    Hebrew: "הקודם",
    Hindi: "पिछला",
    Bengali: "পূর্ববর্তী",
    Hungarian: "Előző",
    Romanian: "Anterior"
  },
  nextLesson: {
    English: "Next Lesson",
    Spanish: "Siguiente lección",
    French: "Leçon suivante",
    German: "Nächste Lektion",
    Chinese: "下一课",
    Japanese: "次のレッスン",
    Korean: "다음 레슨",
    Portuguese: "Próxima lição",
    Italian: "Lezione successiva",
    Russian: "Следующий урок",
    Arabic: "الدرس التالي",
    Hebrew: "השיעור הבא",
    Hindi: "अगला पाठ",
    Bengali: "পরবর্তী পাঠ",
    Hungarian: "Következő lecke",
    Romanian: "Lecția următoare"
  },
  tapMicrophoneToStart: {
    English: "Tap microphone to start",
    Spanish: "Toca el micrófono para empezar",
    French: "Appuyez sur le micro pour commencer",
    German: "Tippen Sie auf das Mikrofon, um zu beginnen",
    Chinese: "点击麦克风开始",
    Japanese: "マイクをタップして開始",
    Korean: "시작하려면 마이크를 탭하세요",
    Portuguese: "Toque no microfone para começar",
    Italian: "Tocca il microfono per iniziare",
    Russian: "Нажмите на микрофон, чтобы начать",
    Arabic: "اضغط على الميكروفون للبدء",
    Hebrew: "לחץ על המיקרופון כדי להתחיל",
    Hindi: "शुरू करने के लिए माइक्रोफ़ोन पर टैप करें",
    Bengali: "শুরু করতে মাইক্রোফোনে ট্যাপ করুন",
    Hungarian: "Koppintson a mikrofonra a kezdéshez",
    Romanian: "Atingeți microfonul pentru a începe"
  },
  hideTranslation: {
    English: "Hide Translation",
    Spanish: "Ocultar traducción",
    French: "Masquer la traduction",
    German: "Übersetzung ausblenden",
    Chinese: "隐藏翻译",
    Japanese: "翻訳を隠す",
    Korean: "번역 숨기기",
    Portuguese: "Ocultar tradução",
    Italian: "Nascondi traduzione",
    Russian: "Скрыть перевод",
    Arabic: "إخفاء الترجمة",
    Hebrew: "הסתר תרגום",
    Hindi: "अनुवाद छिपाएं",
    Bengali: "অনুবাদ লুকান",
    Hungarian: "Fordítás elrejtése",
    Romanian: "Ascunde traducerea"
  },
  customPractice: {
    English: "Custom Practice",
    Spanish: "Práctica personalizada",
    French: "Pratique personnalisée",
    German: "Benutzerdefinierte Übung",
    Chinese: "自定义练习",
    Japanese: "カスタム練習",
    Korean: "사용자 지정 연습",
    Portuguese: "Prática personalizada",
    Italian: "Pratica personalizzata",
    Russian: "Пользовательская практика",
    Arabic: "ممارسة مخصصة",
    Hebrew: "תרגול מותאם אישית",
    Hindi: "कस्टम अभ्यास",
    Bengali: "কাস্টম অনুশীলন",
    Hungarian: "Egyéni gyakorlás",
    Romanian: "Practică personalizată"
  },
  relatedPhrase: {
    English: "Related Phrase",
    Spanish: "Frase relacionada",
    French: "Phrase associée",
    German: "Verwandter Satz",
    Chinese: "相关短语",
    Japanese: "関連フレーズ",
    Korean: "관련 문구",
    Portuguese: "Frase relacionada",
    Italian: "Frase correlata",
    Russian: "Похожая фраза",
    Arabic: "عبارة ذات صلة",
    Hebrew: "ביטוי קשור",
    Hindi: "संबंधित वाक्यांश",
    Bengali: "সম্পর্কিত বাক্যাংশ",
    Hungarian: "Kapcsolódó kifejezés",
    Romanian: "Frază înrudită"
  },
  enterTextToPractice: {
    English: "Enter text in your language...",
    Spanish: "Ingresa texto en tu idioma...",
    French: "Saisissez du texte dans votre langue...",
    German: "Text in Ihrer Sprache eingeben...",
    Chinese: "输入您的语言文本...",
    Japanese: "母国語でテキストを入力...",
    Korean: "언어로 텍스트 입력...",
    Portuguese: "Digite o texto em seu idioma...",
    Italian: "Inserisci testo nella tua lingua...",
    Russian: "Введите текст на вашем языке...",
    Arabic: "أدخل النص بلغتك...",
    Hebrew: "הזן טקסט בשפה שלך...",
    Hindi: "अपनी भाषा में टेक्स्ट दर्ज करें...",
    Bengali: "আপনার ভাষায় পাঠ্য লিখুন...",
    Hungarian: "Írjon be szöveget a nyelvén...",
    Romanian: "Introduceți text în limba dvs..."
  },
  translateAndPractice: {
    English: "Translate & Practice",
    Spanish: "Traducir y practicar",
    French: "Traduire et pratiquer",
    German: "Übersetzen & Üben",
    Chinese: "翻译并练习",
    Japanese: "翻訳して練習",
    Korean: "번역 및 연습",
    Portuguese: "Traduzir e praticar",
    Italian: "Traduci e pratica",
    Russian: "Перевести и практиковать",
    Arabic: "ترجم ومارس",
    Hebrew: "תרגם ותרגל",
    Hindi: "अनुवाद करें और अभ्यास करें",
    Bengali: "অনুবাদ এবং অনুশীলন করুন",
    Hungarian: "Fordítás és gyakorlás",
    Romanian: "Traduceți și exersați"
  },
  translationNotFound: {
    English: "Translation not found. Try English.",
    Spanish: "Traducción no encontrada. Prueba en inglés.",
    French: "Traduction introuvable. Essayez l'anglais.",
    German: "Übersetzung nicht gefunden. Versuchen Sie Englisch.",
    Chinese: "未找到翻译。尝试英语。",
    Japanese: "翻訳が見つかりません。英語を試してください。",
    Korean: "번역을 찾을 수 없습니다. 영어를 시도하세요.",
    Portuguese: "Tradução não encontrada. Tente inglês.",
    Italian: "Traduzione non trovata. Prova l'inglese.",
    Russian: "Перевод не найден. Попробуйте английский.",
    Arabic: "الترجمة غير موجودة. جرب الإنجليزية.",
    Hebrew: "התרגום לא נמצא. נסה אנגלית.",
    Hindi: "अनुवाद नहीं मिला। अंग्रेजी का प्रयास करें।",
    Bengali: "অনুবাদ পাওয়া যায়নি। ইংরেজি চেষ্টা করুন।",
    Hungarian: "A fordítás nem található. Próbálja angolul.",
    Romanian: "Traducerea nu a fost găsită. Încercați engleza."
  },
  showTranslation: {
    English: "Show Translation",
    Spanish: "Mostrar traducción",
    French: "Afficher la traduction",
    German: "Übersetzung anzeigen",
    Chinese: "显示翻译",
    Japanese: "翻訳を表示",
    Korean: "번역 보기",
    Portuguese: "Mostrar tradução",
    Italian: "Mostra traduzione",
    Russian: "Показать перевод",
    Arabic: "إظهار الترجمة",
    Hebrew: "הצג תרגום",
    Hindi: "अनुवाद दिखाएं",
    Bengali: "অনুবাদ দেখান",
    Hungarian: "Fordítás megjelenítése",
    Romanian: "Afișează traducerea"
  },
  readyForAnalysis: {
    English: "Ready for Analysis",
    Spanish: "Listo para el análisis",
    French: "Prêt pour l'analyse",
    German: "Bereit zur Analyse",
    Chinese: "准备分析",
    Japanese: "分析の準備ができました",
    Korean: "분석 준비 완료",
    Portuguese: "Pronto para análise",
    Italian: "Pronto per l'analisi",
    Russian: "Готов к анализу",
    Arabic: "جاهز للتحليل",
    Hebrew: "מוכן לניתוח",
    Hindi: "विश्लेषण के लिए तैयार",
    Bengali: "বিশ্লেষণের জন্য প্রস্তুত",
    Hungarian: "Elemzésre kész",
    Romanian: "Gata pentru analiză"
  },
  recordYourSpeechToGetInstantFeedback: {
    English: "Record your speech to get instant feedback",
    Spanish: "Graba tu voz para obtener comentarios instantáneos",
    French: "Enregistrez votre discours pour obtenir un retour instantané",
    German: "Nehmen Sie Ihre Rede auf, um sofortiges Feedback zu erhalten",
    Chinese: "录制您的语音以获得即时反馈",
    Japanese: "音声を録音して即座にフィードバックを受け取る",
    Korean: "즉각적인 피드백을 받으려면 음성을 녹음하세요",
    Portuguese: "Grave sua fala para obter feedback instantâneo",
    Italian: "Registra il tuo discorso per ricevere un feedback istantaneo",
    Russian: "Запишите свою речь, чтобы получить мгновенный отзыв",
    Arabic: "سجل حديثك للحصول على تعليقات فورية",
    Hebrew: "הקלט את הדיבור שלך כדי לקבל משוב מיידי",
    Hindi: "तत्काल प्रतिक्रिया पाने के लिए अपना भाषण रिकॉर्ड करें",
    Bengali: "তাত্ক্ষণিক প্রতিক্রিয়া পেতে আপনার বক্তৃতা রেকর্ড করুন",
    Hungarian: "Rögzítse beszédét az azonnali visszajelzéshez",
    Romanian: "Înregistrează-ți discursul pentru a primi feedback instantaneu"
  },
  performance: {
    English: "Performance",
    Spanish: "Rendimiento",
    French: "Performance",
    German: "Leistung",
    Chinese: "表现",
    Japanese: "パフォーマンス",
    Korean: "성과",
    Portuguese: "Desempenho",
    Italian: "Prestazione",
    Russian: "Производительность",
    Arabic: "الأداء",
    Hebrew: "ביצועים",
    Hindi: "प्रदर्शन",
    Bengali: "কর্মক্ষমতা",
    Hungarian: "Teljesítmény",
    Romanian: "Performanță"
  },
  aiAssessment: {
    English: "AI Assessment",
    Spanish: "Evaluación de IA",
    French: "Évaluation par l'IA",
    German: "KI-Bewertung",
    Chinese: "AI 评估",
    Japanese: "AI 評価",
    Korean: "AI 평가",
    Portuguese: "Avaliação de IA",
    Italian: "Valutazione dell'IA",
    Russian: "Оценка ИИ",
    Arabic: "تقييم الذكاء الاصطناعي",
    Hebrew: "הערכת בינה מלאכותית",
    Hindi: "एआई मूल्यांकन",
    Bengali: "এআই মূল্যায়ন",
    Hungarian: "MI-értékelés",
    Romanian: "Evaluare AI"
  },
  speechAnalysis: {
    English: "Speech Analysis",
    Spanish: "Análisis del habla",
    French: "Analyse de la parole",
    German: "Sprachanalyse",
    Chinese: "语音分析",
    Japanese: "音声分析",
    Korean: "음성 분석",
    Portuguese: "Análise de fala",
    Italian: "Analisi del parlato",
    Russian: "Анализ речи",
    Arabic: "تحليل الكلام",
    Hebrew: "ניתוח דיבור",
    Hindi: "भाषण विश्लेषण",
    Bengali: "বক্তৃতা বিশ্লেষণ",
    Hungarian: "Beszédelemzés",
    Romanian: "Analiza vorbirii"
  },
  correct: {
    English: "Correct",
    Spanish: "Correcto",
    French: "Correct",
    German: "Richtig",
    Chinese: "正确",
    Japanese: "正解",
    Korean: "정확함",
    Portuguese: "Correto",
    Italian: "Corretto",
    Russian: "Правильно",
    Arabic: "صحيح",
    Hebrew: "נכון",
    Hindi: "सही",
    Bengali: "সঠিক",
    Hungarian: "Helyes",
    Romanian: "Corect"
  },
  mistake: {
    English: "Mistake",
    Spanish: "Error",
    French: "Erreur",
    German: "Fehler",
    Chinese: "错误",
    Japanese: "間違い",
    Korean: "실수",
    Portuguese: "Erro",
    Italian: "Errore",
    Russian: "Ошибка",
    Arabic: "خطأ",
    Hebrew: "טעות",
    Hindi: "गलती",
    Bengali: "ভুল",
    Hungarian: "Hiba",
    Romanian: "Greșeală"
  },
  signIn: {
    English: "Sign In",
    Spanish: "Iniciar sesión",
    French: "Se connecter",
    German: "Anmelden",
    Chinese: "登录",
    Japanese: "サインイン",
    Korean: "로그인",
    Portuguese: "Entrar",
    Italian: "Accedi",
    Russian: "Войти",
    Arabic: "تسجيل الدخول",
    Hebrew: "התחבר",
    Hindi: "साइन इन करें",
    Bengali: "সাইন ইন করুন",
    Hungarian: "Bejelentkezés",
    Romanian: "Autentificare"
  },
  signOut: {
    English: "Sign Out",
    Spanish: "Cerrar sesión",
    French: "Se déconnecter",
    German: "Abmelden",
    Chinese: "退出登录",
    Japanese: "サインアウト",
    Korean: "로그아웃",
    Portuguese: "Sair",
    Italian: "Esci",
    Russian: "Выйти",
    Arabic: "تسجيل الخروج",
    Hebrew: "התנתק",
    Hindi: "साइन आउट करें",
    Bengali: "সাইন আউট করুন",
    Hungarian: "Kijelentkezés",
    Romanian: "Deconectare"
  },
  language: {
    English: "Language",
    Spanish: "Idioma",
    French: "Langue",
    German: "Sprache",
    Chinese: "语言",
    Japanese: "言語",
    Korean: "언어",
    Portuguese: "Idioma",
    Italian: "Lingua",
    Russian: "Язык",
    Arabic: "اللغة",
    Hebrew: "שפה",
    Hindi: "भाषा",
    Bengali: "ভাষা",
    Hungarian: "Nyelv",
    Romanian: "Limbă"
  },
  chooseALanguage: {
    English: "Choose a language",
    Spanish: "Elige un idioma",
    French: "Choisissez une langue",
    German: "Wählen Sie eine Sprache",
    Chinese: "选择语言",
    Japanese: "言語を選択",
    Korean: "언어 선택",
    Portuguese: "Escolha um idioma",
    Italian: "Scegli una lingua",
    Russian: "Выберите язык",
    Arabic: "اختر لغة",
    Hebrew: "בחר שפה",
    Hindi: "एक भाषा चुनें",
    Bengali: "একটি ভাষা চয়ন করুন",
    Hungarian: "Válasszon nyelvet",
    Romanian: "Alege o limbă"
  },
  speak: {
    English: "Speak",
    Spanish: "Hablar",
    French: "Parler",
    German: "Sprechen",
    Chinese: "说话",
    Japanese: "話す",
    Korean: "말하기",
    Portuguese: "Falar",
    Italian: "Parla",
    Russian: "Говорить",
    Arabic: "تحدث",
    Hebrew: "לדבר",
    Hindi: "बोलें",
    Bengali: "কথা বলুন",
    Hungarian: "Beszéljen",
    Romanian: "Vorbește"
  },
  Greetings: {
    English: "Greetings",
    Spanish: "Saludos",
    French: "Salutations",
    German: "Begrüßungen",
    Chinese: "问候",
    Japanese: "挨拶",
    Korean: "인사",
    Portuguese: "Saudações",
    Italian: "Saluti",
    Russian: "Приветствия",
    Arabic: "تحيات",
    Hebrew: "ברכות",
    Hindi: "अभिवादन",
    Bengali: "শুভেচ্ছা",
    Hungarian: "Üdvözlések",
    Romanian: "Salutări"
  },
  Family: {
    English: "Family",
    Spanish: "Familia",
    French: "Famille",
    German: "Familie",
    Chinese: "家庭",
    Japanese: "家族",
    Korean: "가족",
    Portuguese: "Família",
    Italian: "Famiglia",
    Russian: "Семья",
    Arabic: "عائلة",
    Hebrew: "משפחה",
    Hindi: "परिवार",
    Bengali: "পরিবার",
    Hungarian: "Család",
    Romanian: "Familie"
  },
  Food: {
    English: "Food",
    Spanish: "Comida",
    French: "Nourriture",
    German: "Essen",
    Chinese: "食物",
    Japanese: "食べ物",
    Korean: "음식",
    Portuguese: "Comida",
    Italian: "Cibo",
    Russian: "Еда",
    Arabic: "طعام",
    Hebrew: "אוכל",
    Hindi: "भोजन",
    Bengali: "খাবার",
    Hungarian: "Étel",
    Romanian: "Mâncare"
  },
  Routine: {
    English: "Routine",
    Spanish: "Rutina",
    French: "Routine",
    German: "Routine",
    Chinese: "日常",
    Japanese: "日課",
    Korean: "일과",
    Portuguese: "Rotina",
    Italian: "Routine",
    Russian: "Рутина",
    Arabic: "روتين",
    Hebrew: "שגרה",
    Hindi: "दिनचर्या",
    Bengali: "রুটিন",
    Hungarian: "Rutin",
    Romanian: "Rutină"
  },
  Hobbies: {
    English: "Hobbies",
    Spanish: "Pasatiempos",
    French: "Loisirs",
    German: "Hobbys",
    Chinese: "爱好",
    Japanese: "趣味",
    Korean: "취미",
    Portuguese: "Passatempos",
    Italian: "Hobby",
    Russian: "Хобби",
    Arabic: "هوايات",
    Hebrew: "תחביבים",
    Hindi: "शौक",
    Bengali: "শখ",
    Hungarian: "Hobbik",
    Romanian: "Hobby-uri"
  },
  Weather: {
    English: "Weather",
    Spanish: "Clima",
    French: "Météo",
    German: "Wetter",
    Chinese: "天气",
    Japanese: "天気",
    Korean: "날씨",
    Portuguese: "Clima",
    Italian: "Meteo",
    Russian: "Погода",
    Arabic: "طقس",
    Hebrew: "מזג אוויר",
    Hindi: "मौसम",
    Bengali: "আবহাওয়া",
    Hungarian: "Időjárás",
    Romanian: "Vreme"
  },
  Home: {
    English: "Home",
    Spanish: "Hogar",
    French: "Maison",
    German: "Zuhause",
    Chinese: "家",
    Japanese: "家",
    Korean: "집",
    Portuguese: "Casa",
    Italian: "Casa",
    Russian: "Дом",
    Arabic: "منزل",
    Hebrew: "בית",
    Hindi: "घर",
    Bengali: "বাড়ি",
    Hungarian: "Otthon",
    Romanian: "Acasă"
  },
  Work: {
    English: "Work",
    Spanish: "Trabajo",
    French: "Travail",
    German: "Arbeit",
    Chinese: "工作",
    Japanese: "仕事",
    Korean: "일",
    Portuguese: "Trabalho",
    Italian: "Lavoro",
    Russian: "Работа",
    Arabic: "عمل",
    Hebrew: "עבודה",
    Hindi: "काम",
    Bengali: "কাজ",
    Hungarian: "Munka",
    Romanian: "Muncă"
  },
  Shopping: {
    English: "Shopping",
    Spanish: "Compras",
    French: "Achats",
    German: "Einkaufen",
    Chinese: "购物",
    Japanese: "買い物",
    Korean: "쇼핑",
    Portuguese: "Compras",
    Italian: "Shopping",
    Russian: "Покупки",
    Arabic: "تسوق",
    Hebrew: "קניות",
    Hindi: "खरीदारी",
    Bengali: "কেনাকাটা",
    Hungarian: "Vásárlás",
    Romanian: "Cumpărături"
  },
  Travel: {
    English: "Travel",
    Spanish: "Viajes",
    French: "Voyage",
    German: "Reisen",
    Chinese: "旅行",
    Japanese: "旅行",
    Korean: "여행",
    Portuguese: "Viagem",
    Italian: "Viaggi",
    Russian: "Путешествия",
    Arabic: "سفر",
    Hebrew: "טיולים",
    Hindi: "यात्रा",
    Bengali: "ভ্রমণ",
    Hungarian: "Utazás",
    Romanian: "Călătorii"
  },
  Health: {
    English: "Health",
    Spanish: "Salud",
    French: "Santé",
    German: "Gesundheit",
    Chinese: "健康",
    Japanese: "健康",
    Korean: "건강",
    Portuguese: "Saúde",
    Italian: "Salute",
    Russian: "Здоровье",
    Arabic: "صحة",
    Hebrew: "בריאות",
    Hindi: "स्वास्थ्य",
    Bengali: "স্বাস্থ্য",
    Hungarian: "Egészség",
    Romanian: "Sănătate"
  },
  Time: {
    English: "Time",
    Spanish: "Tiempo",
    French: "Temps",
    German: "Zeit",
    Chinese: "时间",
    Japanese: "時間",
    Korean: "시간",
    Portuguese: "Tempo",
    Italian: "Tempo",
    Russian: "Время",
    Arabic: "وقت",
    Hebrew: "זמן",
    Hindi: "समय",
    Bengali: "সময়",
    Hungarian: "Idő",
    Romanian: "Timp"
  },
  Technology: {
    English: "Technology",
    Spanish: "Tecnología",
    French: "Technologie",
    German: "Technologie",
    Chinese: "技术",
    Japanese: "技術",
    Korean: "기술",
    Portuguese: "Tecnologia",
    Italian: "Tecnologia",
    Russian: "Технологии",
    Arabic: "تكنولوجيا",
    Hebrew: "טכנולוגיה",
    Hindi: "प्रौद्योगिकी",
    Bengali: "প্রযুক্তি",
    Hungarian: "Technológia",
    Romanian: "Tehnologie"
  },
  Nature: {
    English: "Nature",
    Spanish: "Naturaleza",
    French: "Nature",
    German: "Natur",
    Chinese: "自然",
    Japanese: "自然",
    Korean: "자연",
    Portuguese: "Natureza",
    Italian: "Natura",
    Russian: "Природа",
    Arabic: "طبيعة",
    Hebrew: "טבע",
    Hindi: "प्रकृति",
    Bengali: "প্রকৃতি",
    Hungarian: "Természet",
    Romanian: "Natură"
  },
  Education: {
    English: "Education",
    Spanish: "Educación",
    French: "Éducation",
    German: "Bildung",
    Chinese: "教育",
    Japanese: "教育",
    Korean: "교육",
    Portuguese: "Educação",
    Italian: "Educazione",
    Russian: "Образование",
    Arabic: "تعليم",
    Hebrew: "חינוך",
    Hindi: "शिक्षा",
    Bengali: "শিক্ষা",
    Hungarian: "Oktatás",
    Romanian: "Educație"
  },
  Culture: {
    English: "Culture",
    Spanish: "Cultura",
    French: "Culture",
    German: "Kultur",
    Chinese: "文化",
    Japanese: "文化",
    Korean: "문화",
    Portuguese: "Cultura",
    Italian: "Cultura",
    Russian: "Культура",
    Arabic: "ثقافة",
    Hebrew: "תרבות",
    Hindi: "संस्कृति",
    Bengali: "সংস্কৃতি",
    Hungarian: "Kultúra",
    Romanian: "Cultură"
  },
  General: {
    English: "General",
    Spanish: "General",
    French: "Général",
    German: "Allgemein",
    Chinese: "一般",
    Japanese: "一般",
    Korean: "일반",
    Portuguese: "Geral",
    Italian: "Generale",
    Russian: "Общее",
    Arabic: "عام",
    Hebrew: "כללי",
    Hindi: "सामान्य",
    Bengali: "সাধারণ",
    Hungarian: "Általános",
    Romanian: "General"
  },
  Business: {
    English: "Business",
    Spanish: "Negocios",
    French: "Affaires",
    German: "Geschäft",
    Chinese: "商务",
    Japanese: "ビジネス",
    Korean: "비즈니스",
    Portuguese: "Negócios",
    Italian: "Affari",
    Russian: "Бизнес",
    Arabic: "أعمال",
    Hebrew: "עסקים",
    Hindi: "व्यापार",
    Bengali: "ব্যবসা",
    Hungarian: "Üzlet",
    Romanian: "Afaceri"
  },
  Academic: {
    English: "Academic",
    Spanish: "Académico",
    French: "Académique",
    German: "Akademisch",
    Chinese: "学术",
    Japanese: "学術",
    Korean: "학술",
    Portuguese: "Acadêmico",
    Italian: "Accademico",
    Russian: "Академический",
    Arabic: "أكاديمي",
    Hebrew: "אקדמי",
    Hindi: "शैक्षणिक",
    Bengali: "একাডেমিক",
    Hungarian: "Akadémiai",
    Romanian: "Academic"
  },
  Global: {
    English: "Global",
    Spanish: "Global",
    French: "Mondial",
    German: "Global",
    Chinese: "全球",
    Japanese: "グローバル",
    Korean: "글로벌",
    Portuguese: "Global",
    Italian: "Globale",
    Russian: "Глобальный",
    Arabic: "عالمي",
    Hebrew: "גלובלי",
    Hindi: "वैश्विक",
    Bengali: "বিশ্বব্যাপী",
    Hungarian: "Globális",
    Romanian: "Global"
  },
  Arts: {
    English: "Arts",
    Spanish: "Artes",
    French: "Arts",
    German: "Künste",
    Chinese: "艺术",
    Japanese: "芸術",
    Korean: "예술",
    Portuguese: "Artes",
    Italian: "Arti",
    Russian: "Искусство",
    Arabic: "فنون",
    Hebrew: "אמנויות",
    Hindi: "कला",
    Bengali: "শিল্প",
    Hungarian: "Művészetek",
    Romanian: "Arte"
  },
  Psychology: {
    English: "Psychology",
    Spanish: "Psicología",
    French: "Psychologie",
    German: "Psychologie",
    Chinese: "心理学",
    Japanese: "心理学",
    Korean: "심리학",
    Portuguese: "Psicologia",
    Italian: "Psicologia",
    Russian: "Психология",
    Arabic: "علم النفس",
    Hebrew: "פסיכולוגיה",
    Hindi: "मनोविज्ञान",
    Bengali: "মনোবিজ্ঞান",
    Hungarian: "Pszichológia",
    Romanian: "Psihologie"
  },
  Philosophy: {
    English: "Philosophy",
    Spanish: "Filosofía",
    French: "Philosophie",
    German: "Philosophie",
    Chinese: "哲学",
    Japanese: "哲学",
    Korean: "철학",
    Portuguese: "Filosofia",
    Italian: "Filosofia",
    Russian: "Философия",
    Arabic: "فلسفة",
    Hebrew: "פילוסופיה",
    Hindi: "दर्शन",
    Bengali: "দর্শন",
    Hungarian: "Filozófia",
    Romanian: "Filozofie"
  },
  Vocabulary: {
    English: "Vocabulary",
    Spanish: "Vocabulario",
    French: "Vocabulaire",
    German: "Wortschatz",
    Chinese: "词汇",
    Japanese: "語彙",
    Korean: "어휘",
    Portuguese: "Vocabulário",
    Italian: "Vocabolario",
    Russian: "Словарный запас",
    Arabic: "مفردات",
    Hebrew: "אוצר מילים",
    Hindi: "शब्दावली",
    Bengali: "শব্দভাণ্ডার",
    Hungarian: "Szókincs",
    Romanian: "Vocabular"
  },
  Grammar: {
    English: "Grammar",
    Spanish: "Gramática",
    French: "Grammaire",
    German: "Grammatik",
    Chinese: "语法",
    Japanese: "文法",
    Korean: "문법",
    Portuguese: "Gramática",
    Italian: "Grammatica",
    Russian: "Грамматика",
    Arabic: "قواعد",
    Hebrew: "דקדוק",
    Hindi: "व्याकरण",
    Bengali: "ব্যাকরণ",
    Hungarian: "Nyelvtan",
    Romanian: "Gramatică"
  },
  Idioms: {
    English: "Idioms",
    Spanish: "Modismos",
    French: "Idiotismes",
    German: "Idiome",
    Chinese: "习语",
    Japanese: "慣用句",
    Korean: "관용구",
    Portuguese: "Expressões idiomáticas",
    Italian: "Idiomi",
    Russian: "Идиомы",
    Arabic: "اصطلاحات",
    Hebrew: "ניבים",
    Hindi: "मुहावरे",
    Bengali: "বাগধারা",
    Hungarian: "Szólások",
    Romanian: "Expresii idiomatice"
  },
  Debate: {
    English: "Debate",
    Spanish: "Debate",
    French: "Débat",
    German: "Debatte",
    Chinese: "辩论",
    Japanese: "討論",
    Korean: "토론",
    Portuguese: "Debate",
    Italian: "Dibattito",
    Russian: "Дебаты",
    Arabic: "مناظرة",
    Hebrew: "דיון",
    Hindi: "बहस",
    Bengali: "বিতর্ক",
    Hungarian: "Vita",
    Romanian: "Dezbatere"
  },
  Abstract: {
    English: "Abstract",
    Spanish: "Abstracto",
    French: "Abstrait",
    German: "Abstrakt",
    Chinese: "抽象",
    Japanese: "抽象",
    Korean: "추상",
    Portuguese: "Abstrato",
    Italian: "Astratto",
    Russian: "Абстрактный",
    Arabic: "مجرد",
    Hebrew: "מופשט",
    Hindi: "अमूर्त",
    Bengali: "বিমূর্ত",
    Hungarian: "Absztrakt",
    Romanian: "Abstract"
  },
  practice: {
    English: "Practice",
    Spanish: "Práctica",
    French: "Pratique",
    German: "Übung",
    Chinese: "练习",
    Japanese: "練習",
    Korean: "연습",
    Portuguese: "Prática",
    Italian: "Pratica",
    Russian: "Практика",
    Arabic: "ممارسة",
    Hebrew: "תרגול",
    Hindi: "अभ्यास",
    Bengali: "অনুশীলন",
    Hungarian: "Gyakorlat",
    Romanian: "Practică"
  },
  dailyPracticeFor: {
    English: "Daily practice for",
    Spanish: "Práctica diaria para",
    French: "Pratique quotidienne pour",
    German: "Tägliche Übung für",
    Chinese: "每日练习：",
    Japanese: "日常練習：",
    Korean: "일일 연습:",
    Portuguese: "Prática diária para",
    Italian: "Pratica quotidiana per",
    Russian: "Ежедневная практика для",
    Arabic: "ممارسة يومية لـ",
    Hebrew: "תרגול יומי עבור",
    Hindi: "के लिए दैनिक अभ्यास",
    Bengali: "এর জন্য দৈনিক অনুশীলন",
    Hungarian: "Napi gyakorlat a következőhöz:",
    Romanian: "Practică zilnică pentru"
  },
  level: {
    English: "level",
    Spanish: "nivel",
    French: "niveau",
    German: "Niveau",
    Chinese: "级别",
    Japanese: "レベル",
    Korean: "레벨",
    Portuguese: "nível",
    Italian: "livello",
    Russian: "уровень",
    Arabic: "مستوى",
    Hebrew: "רמה",
    Hindi: "स्तर",
    Bengali: "স্তর",
    Hungarian: "szint",
    Romanian: "nivel"
  },
  beginner: {
    English: "Beginner",
    Spanish: "Principiante",
    French: "Débutant",
    German: "Anfänger",
    Chinese: "初级",
    Japanese: "初級",
    Korean: "초급",
    Portuguese: "Iniciante",
    Italian: "Principiante",
    Russian: "Начинающий",
    Arabic: "مبتدئ",
    Hebrew: "מתחיל",
    Hindi: "शुरुआती",
    Bengali: "শিক্ষানবিস",
    Hungarian: "Kezdő",
    Romanian: "Începător"
  },
  intermediate: {
    English: "Intermediate",
    Spanish: "Intermedio",
    French: "Intermédiaire",
    German: "Mittelstufe",
    Chinese: "中级",
    Japanese: "中級",
    Korean: "중급",
    Portuguese: "Intermediário",
    Italian: "Intermedio",
    Russian: "Средний",
    Arabic: "متوسط",
    Hebrew: "בינוני",
    Hindi: "मध्यम",
    Bengali: "মধ্যবর্তী",
    Hungarian: "Középhaladó",
    Romanian: "Intermediar"
  },
  advanced: {
    English: "Advanced",
    Spanish: "Avanzado",
    French: "Avancé",
    German: "Fortgeschritten",
    Chinese: "高级",
    Japanese: "上級",
    Korean: "고급",
    Portuguese: "Avançado",
    Italian: "Avanzato",
    Russian: "Продвинутый",
    Arabic: "متقدم",
    Hebrew: "מתקדם",
    Hindi: "उन्नत",
    Bengali: "উন্নত",
    Hungarian: "Haladó",
    Romanian: "Avansat"
  },
  all: {
    English: "All",
    Spanish: "Todos",
    French: "Tous",
    German: "Alle",
    Chinese: "全部",
    Japanese: "すべて",
    Korean: "전체",
    Portuguese: "Todos",
    Italian: "Tutti",
    Russian: "Все",
    Arabic: "جميع",
    Hebrew: "הכל",
    Hindi: "सभी",
    Bengali: "সব",
    Hungarian: "Minden",
    Romanian: "Toate"
  },
  unit: {
    English: "Unit",
    Spanish: "Unidad",
    French: "Unité",
    German: "Einheit",
    Chinese: "单元",
    Japanese: "ユニット",
    Korean: "단원",
    Portuguese: "Unidade",
    Italian: "Unità",
    Russian: "Юнит",
    Arabic: "وحدة",
    Hebrew: "יחידה",
    Hindi: "इकाई",
    Bengali: "ইউনিট",
    Hungarian: "Egység",
    Romanian: "Unitate"
  },
  of: {
    English: "of",
    Spanish: "de",
    French: "sur",
    German: "von",
    Chinese: "/",
    Japanese: "/",
    Korean: "/",
    Portuguese: "de",
    Italian: "di",
    Russian: "из",
    Arabic: "من",
    Hebrew: "מתוך",
    Hindi: "में से",
    Bengali: "এর মধ্যে",
    Hungarian: "/",
    Romanian: "din"
  },
  noLessonsFound: {
    English: "No lessons found",
    Spanish: "No se encontraron lecciones",
    French: "Aucune leçon trouvée",
    German: "Keine Lektionen gefunden",
    Chinese: "未找到课程",
    Japanese: "レッスンが見つかりません",
    Korean: "레슨을 찾을 수 없습니다",
    Portuguese: "Nenhuma lição encontrada",
    Italian: "Nessuna lezione trovata",
    Russian: "Уроки не найдены",
    Arabic: "لم يتم العثور على دروس",
    Hebrew: "לא נמצאו שיעורים",
    Hindi: "कोई पाठ नहीं मिला",
    Bengali: "কোন পাঠ পাওয়া যায়নি",
    Hungarian: "Nem található lecke",
    Romanian: "Nu s-au găsit lecții"
  },
  curriculum: {
    English: "Curriculum",
    Spanish: "Currículo",
    French: "Programme",
    German: "Lehrplan",
    Chinese: "课程",
    Japanese: "カリキュラム",
    Korean: "커리큘럼",
    Portuguese: "Currículo",
    Italian: "Programma",
    Russian: "Учебный план",
    Arabic: "المنهج الدراسي",
    Hebrew: "תוכנית לימודים",
    Hindi: "पाठ्यक्रम",
    Bengali: "পাঠ্যক্রম",
    Hungarian: "Tanterv",
    Romanian: "Curriculum"
  },
  searchPlaceholder: {
    English: "Search...",
    Spanish: "Buscar...",
    French: "Rechercher...",
    German: "Suchen...",
    Chinese: "搜索...",
    Japanese: "検索...",
    Korean: "검색...",
    Portuguese: "Pesquisar...",
    Italian: "Cerca...",
    Russian: "Поиск...",
    Arabic: "بحث...",
    Hebrew: "חיפוש...",
    Hindi: "खोजें...",
    Bengali: "অনুসন্ধান...",
    Hungarian: "Keresés...",
    Romanian: "Caută..."
  }
};
